export const authCompleteEvent = "auth-complete";

export function VimeoAuthComplete() {
    const currentLocation = `${window.location.protocol}//${window.location.hostname}`;
    window.opener?.postMessage(authCompleteEvent, currentLocation);
    window.close();
    return (
        <p className="slds-align_absolute-center slds-var-p-around_medium">
            You have signed in to your Vimeo account. You may close this window.
        </p>
    );
}
